export default "<button style=\"margin-top:20px\" mat-raised-button color=\"primary\" (click)=\"generateQrCode()\">Generate QR Code</button>\r\n";